/* eslint-disable no-console */
import React, { useContext, useEffect, useState } from 'react';
import { Grid, Box, Typography, Stack } from '@mui/material';
import { IoClose } from 'react-icons/io5';
import { IoIosLink } from 'react-icons/io';
import { createFeedContext } from '../..';
import Loading from '../../../../../../../../components/Common/Loaders/FullWidthLoader/Loading';
import { getLinkPreviewD } from '../../../../../../../actions/feeds_actions_new';

const MetaData = (props) =>
{
	const { link, index } = props;
	const [ metadata, setMetadata ] = useState(false);
	const { setCreateFeed } = useContext(createFeedContext);
	const [ previewData, setPreviewData ] = useState<any>({});
	const [ loading, setLoading ] = useState<boolean>(false);

	if (link?.type !== 'link') return <></>;

	useEffect(() =>
	{
		// if (createFeed?.hasOwnProperty('link') && createFeed?.link !== '')
		if (link?.type === 'link' && link?.url)
		{
			fetchPreview(link?.url);
		}
		else
		{
			setPreviewData({});
		}
	}, []);

	async function fetchPreview(typedLink)
	{
		setLoading(true);
		try
		{
		// properly encodedspaces, slashes, colons, question marks
			const response = await getLinkPreviewD(encodeURIComponent(typedLink));

			// await axios.get(`https://opengraph.io/api/1.1/site/${encodeURIComponent(typedLink)}?app_id=${process.env.REACT_APP_LINK_PREVIEW_KEY}`);

			setPreviewData(response.data);

			setCreateFeed((prev) =>
			{
				const mediaList = prev?.media ?? [];
				const newObj = {
					...mediaList[index],
					name  : response?.data?.hybridGraph?.title ?? '',
					title : response?.data?.hybridGraph?.title ?? ''
				};

				mediaList[index] = newObj;

				return ({ ...prev, media: mediaList });
			});
		}
		catch (err)
		{
			setPreviewData({});
			setCreateFeed((prev) =>
			{
				const mediaList = prev?.media ?? [];
				const newObj = {
					...mediaList[index],
					name  : typedLink,
					title : typedLink
				};

				mediaList[index] = newObj;

				return ({ ...prev, media: mediaList });
			});
		}
		finally
		{
			setLoading(false);
		}
	}

	const removeLink = () =>
	{
		// setCreateFeed((prev) => ({ ...prev, link: '' }));
		setCreateFeed((prev) =>
		{
			const mediaList = prev?.media ? [ ...prev?.media ] : [];

			mediaList.splice(index, 1);

			return ({ ...prev, media: mediaList });
		});
	};

	return (
		<>
			<Grid container alignItems={'center'} py='var(--pixel8)'>
				{loading && <Loading/>}
				{!metadata && !loading
					? <>
						<Grid item xs minWidth={0} border={'1px solid var(--black)'} p='var(--pixel8)' borderRadius={'var(--pixel8)'}>
							<Grid container alignItems={'center'} display={'flex'}>
								<Grid item>
									<Box width={'50px'} height={'50px'} display={'flex'} alignItems={'center'}>
										<img src={previewData?.hybridGraph?.favicon || previewData?.hybridGraph?.image || '/images/metadataImg.svg'} alt='' />
									</Box>
								</Grid>
								<Grid item xs minWidth={0} pl='var(--pixel8)'>
									<Stack direction={'column'}>
										<Stack direction={'row'} alignItems={'center'} justifyContent={'space-between'}>
											<Typography textOverflow={'ellipsis'} whiteSpace={'nowrap'} overflow={'hidden'} fontSize={'var(--pixel12)'} fontWeight='var(--font500)'>
												{previewData?.hybridGraph?.title || ''}
											</Typography>
											{/* <IoClose style={{ cursor: 'pointer' }} onClick={() => setMetadata(!metadata)}/> */}
											<IoClose style={{ cursor: 'pointer' }} onClick={removeLink}/>
										</Stack>
									</Stack>
									<Typography textOverflow={'ellipsis'} whiteSpace={'nowrap'} overflow={'hidden'} fontSize={'var(--pixel12)'} fontWeight='var(--font500)'>
										{previewData?.hybridGraph?.description || link.name || ''}
									</Typography>
									<Stack direction={'row'} alignItems={'center'}>
										<IoIosLink style={{ cursor: 'pointer' }} />
										<Typography textOverflow={'ellipsis'} whiteSpace={'nowrap'} overflow={'hidden'} fontSize={'var(--pixel12)'} fontWeight='var(--font500)'>
											{previewData?.hybridGraph?.url}
										</Typography>
									</Stack>
								</Grid>
							</Grid>
						</Grid>
						<Grid item pl='var(--pixel8)'>
							<IoIosLink fontSize={'var(--pixel22)'} style={{ cursor: 'pointer' }} onClick={() => setMetadata(!metadata)} />
						</Grid>
					</>
					: <Grid item xs display={'flex'} flexDirection={'row'} alignItems={'center'}>
						<Typography maxWidth={'var(--font200)'} textOverflow={'ellipsis'} whiteSpace={'nowrap'} overflow={'hidden'}
							color={'var(--primaryColor)'}
						>
							{link?.url}
						</Typography>
						<IoIosLink style={{ cursor: 'pointer' }} onClick={() => setMetadata(!metadata)}/>
					</Grid>
				}
			</Grid>
		</>
	);
};

export default MetaData;